export const ProjectFilterType = {
  LATEST: 'LATEST',
  RANDOM: 'RANDOM',
  WORK_IN_PROGRESS: 'WORK_IN_PROGRESS'
};

export const projectFilterTypes = [
  ProjectFilterType.LATEST,
  ProjectFilterType.RANDOM,
  ProjectFilterType.WORK_IN_PROGRESS,
];
